import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import BTextField from 'JS/components/blain-form/BTextField.vue';
import EmailSubscriptionService from '../../../services/EmailSubscriptionService';
import { computed, onMounted, ref } from 'vue';
import { validateEmail } from '../../../helpers/functions.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToylandSignup',
  setup(__props) {

const nowDate = ref(new Date());

const availableFrom = new Date('2025-10-02T00:00:00'); // local time October 2, 2025 00:00:00
const availableTo = new Date('2025-12-25T23:59:59'); // local time December 25, 2025 23:59:59

const catalogAvailable = computed(() => {
	return availableFrom <= nowDate.value && nowDate.value <= availableTo;
});

const isPost2025Catalog = computed(() => {
	return availableTo <= nowDate.value;
});

const email = ref('');
const sendSuccess = ref(false);
const loading = ref(false);
const error = ref('');

const emailService = new EmailSubscriptionService();

async function emailSignup() {
	error.value = "";
	
	if (!validateEmail(email.value)) {
		error.value = "Please enter a valid email";
		return;
	}
	
	loading.value = true;

	try {
		const result = await emailService.subscribeEmailToMarketing(email.value);

		if (!result.success) {
		
		}

		sendSuccess.value = true;
	} catch (error) {
		console.error('Error sending email:', error.message);
	}

	loading.value = false;
}

/**
 * Used for testing purposes. Could remove or comment after development done
 */
function getTestDateFromUrl(): Date | null {
	const urlParams = new URLSearchParams(window.location.search);
	const testDate = urlParams.get('testDate');
	if (!testDate) {
		return null;
	}

	if (!/^\d{14}$/.test(testDate)) {
		console.error('Invalid date string format. Expected YYYYMMDDHHMMSS');
	}

	const year = parseInt(testDate.slice(0, 4));
	const month = parseInt(testDate.slice(4, 6)) - 1; // Months are 0-indexed
	const day = parseInt(testDate.slice(6, 8));
	const hour = parseInt(testDate.slice(8, 10));
	const minute = parseInt(testDate.slice(10, 12));
	const second = parseInt(testDate.slice(12, 14));

	return new Date(year, month, day, hour, minute, second);
};

onMounted(() => {
	const testDate = getTestDateFromUrl();
	if (testDate) {
		nowDate.value = testDate;
	}
});

return { __sfc: true,nowDate, availableFrom, availableTo, catalogAvailable, isPost2025Catalog, email, sendSuccess, loading, error, emailService, emailSignup, getTestDateFromUrl, BButton, BTextField }
}

})